import request from '@/utils/request'
import { requestPath } from '@/utils/global.js'
export function getSubjectAPI (params) {
    return request({
        url: `${requestPath.resource}/ebookMainBody/list`,
        method: 'get',
        params
    })
}
export function getYearAPI (params) {
    return request({
        url: `${requestPath.resource}/ebookMainBody/year?oid=${params}`,
        method: 'get'
    })
}
export function getEbookAPI (params) {
    return request({
        url: `${requestPath.resource}/ebook/get?id=${params}`,
        method: 'get'
    })
}
export function getEpubAPI (oid) {
    return request({
        url: `${requestPath.resource}/ebook/get/${oid}`,
        method: 'get'
    })
}
export function gethoswAPI (params) {
    return request({
        url: `${requestPath.common}/hotsw/list?num=${params}`,
        method: 'get'
    })
}
export function getListAPI (params) {
    return request({
        url: `${requestPath.resource}/ebook/page-book`,
        method: 'get',
        params
    })
}
export function getArticleAPI (params) {
    return request({
        url: `${requestPath.resource}/article-library/get/${params}`,
        method: 'get'
    })
}


// WEBPACK FOOTER //
// ./src/api/index/index.js